import moment from 'moment';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Message } from 'primereact/message';
import { useState } from 'react';
import Data from '../../../../components/Display/Data';
import DataTag from '../../../../components/Display/DataTag';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import { getConstant } from '../../../../utils/constants';
import ImageItem from '../../common/image/ImageItem';
import DistributionItem from '../distribution/DistributionItem';
import styles from "../../../../components/Display/Wrapper.module.scss";

const ASPECT_RATIO = 1.71;

function EventDetail({
  event,
  handleUpdateEvent,
  handleUpdateDistribution,
  handleUpdateDistributionList,
  handleDeleteDistribution,
  handleDelete
}) {
  const [mainImageisValid, setMainImageisValid] = useState(true);
  const [secondaryImageIsValid, setSecondaryImageIsValid] = useState(true);

  const updateEventActions = [
    {
      onClick: handleUpdateEvent,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const editionDistributionActions = [
    {
      onClick: handleUpdateDistributionList,
      label: 'Modifier la distribution',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (event) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cet évenement ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(event)
    });
  };

  // Image is valid if width == height
  const computeMainImageShape = (img) => {
    setMainImageisValid(
      (img.nativeEvent.srcElement.naturalWidth / img.nativeEvent.srcElement.naturalHeight).toFixed(
        2
      ) == ASPECT_RATIO
    );
  };

  const computeSecondaryImageShape = (img) => {
    setSecondaryImageIsValid(
      (img.nativeEvent.srcElement.naturalWidth / img.nativeEvent.srcElement.naturalHeight).toFixed(
        2
      ) == ASPECT_RATIO
    );
  };

  return (
    <div className={styles.scrollableSectionContainer}>
      <Section label="Informations Générales" actions={updateEventActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={event.title} large />
          <DataTag
            key="status"
            label="État"
            tag={getConstant('banquetceleste.common.statusTypes', event.status)}
            rounded
            large
          />
          <Data
            key="start_dt"
            label={'Date de début'}
            value={moment(event.start_dt).format('LLL')}
            large
          />
          <Data
            key="end_dt"
            label={'Date de fin'}
            value={moment(event.end_dt).format('LLL')}
            large
          />
        </div>
        <div className="flex flex-wrap gap-5">
          <DataTag
            key="program"
            label="Programme lié"
            tag={{
              label: event.program?.title,
              bgColor: 'bg-slate-700',
              icon: 'program'
            }}
            large
          />
          <Data key="place_name" label={'Lieu'} value={event.place_name} large />
          <Data
            key="cta_label"
            label={'Label de la page de réservation'}
            value={event.cta_label}
            large
          />
          <Data key="cta_url" label={'URL de la page de réservation'} value={event.cta_url} large />
        </div>
        <MultiLineData
          key="description"
          label={'Description'}
          value={event.description}
          large
          asHtml
        />
      </Section>
      <div className="flex flex-wrap gap-5">
        <Section label="Image principale">
          {!mainImageisValid && event.main_image && (
            <div>
              <Message
                severity="warn"
                text={`Cette image n'est pas au ratio ${ASPECT_RATIO}:1, l'affichage sur le site ne sera pas optimal.`}
              />
            </div>
          )}
          <ImageItem image={event.main_image} imageLoad={computeMainImageShape} className="w-96" />
        </Section>
        <Section label="Image secondaire">
          {!secondaryImageIsValid && event.secondary_image && (
            <div>
              <Message
                severity="warn"
                text={`Cette image n'est pas au ratio ${ASPECT_RATIO}:1, l'affichage sur le site ne sera pas optimal.`}
              />
            </div>
          )}
          <ImageItem
            image={event.secondary_image}
            imageLoad={computeSecondaryImageShape}
            className="w-96"
          />
        </Section>
      </div>
      <Section label="Distribution" actions={editionDistributionActions}>
        {event.distributions?.length > 0 ? (
          <div className="flex flex-col gap-3">
            {event.distributions.map((distrib, id) => (
              <DistributionItem
                key={id}
                distribution={distrib}
                handleUpdateDistribution={() => handleUpdateDistribution(distrib)}
                handleDeleteDistribution={() => handleDeleteDistribution(distrib)}
              />
            ))}
          </div>
        ) : (
          <p className="italic text-slate-400 font-light">Non renseignée</p>
        )}
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={"Supprimer l'évenement"}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(event)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default EventDetail;
